import { render, staticRenderFns } from "./history-grade-list.vue?vue&type=template&id=639ed19a&scoped=true&"
import script from "./history-grade-list.vue?vue&type=script&lang=js&"
export * from "./history-grade-list.vue?vue&type=script&lang=js&"
import style0 from "./history-grade-list.vue?vue&type=style&index=0&id=639ed19a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639ed19a",
  null
  
)

export default component.exports